// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"23831e5db35e6ea24e75","811":"c03e45964981ad4c1817","889":"658afe66027cb24e1aec"}[chunkId] + ".css";
};